<template>
  <div v-if="properties"/>
</template>

<script>
const OPTIONS = () => {
  return {
    // main
    field: '',
    value: '',
    customBehaviour: false
  }
}
export default {
  name: 'EditorCheckbox',
  props: {
    options: { type: Object },
    data: { type: Object, required: true },
    isEdit: { type: Boolean, default: false }
  },
  watch: {
    options: 'parserOptions',
    data: 'parserDate',
    isEdit: 'handleIsVisible'
  },
  data () {
    return {
      model: true,
      properties: null
    }
  },
  created () {
    this.parserOptions()
    this.parserDate()
  },
  mounted () {
    this.$emit('submit')
  },
  methods: {
    // General Parser
    parserOptions () {
      this.properties = this.$_.merge(OPTIONS(), this.options)
    },
    parserDate () {
      this.model = this.data[this.properties.field]
    },
    // PUBLIC
    validate () {
      return new Promise(resolve => {
        resolve(this.getValue())
      })
    },
    getValue () {
      let result = {}
      result[this.properties.field] = !this.model
      return result
    }
  }
}
</script>
